module.exports = __webpack_public_path__ + "img/telhado-paraf-metal.4f0d6e92.jpg";